module.exports = __webpack_public_path__ + "img/0a75070b8d70c309a692c58f8e70607f.png";